export const PAYMENT_OPERATION_STATUSES = [
    { text: 'Запрос на пополнение', value: 'request' },
    { text: 'Кредит', value: 'credit' },
    { text: 'Оплаченный платеж', value: 'paid' }
];
